module.exports = __webpack_public_path__ + "img/rotate.2dd215b4.svg";